import { createBrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';

// Create the router with layout type only (theme will be from state)
const Router = createBrowserRouter(AppRoutes);

export default Router;
